import { faBan, faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAsyncResource } from 'use-async-resource';
import { BranchesContext } from '../../context/BranchesContext';
import { useGetConfigColors } from '../../utils/configuration-hooks';
import {useGetAllMainGroups} from "../../utils/groups-hooks";
import Select from "react-select";
import {useGetUsers} from "../../utils/users-hooks";
import {optionSelectStyles} from "../../styles/selectStyles";
import {User} from "../../models/table-models";
import { AuthContext } from '../../context/AuthContext';
import { Role } from '../../utils/Enums/Roles';

export const BranchesStateFilter = () => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const [selectedButton, setSelectedButton] = useState<number | null>(null);
    const [getColors] = useAsyncResource(useGetConfigColors, []);
    const { filterBranchesByState, filterBranchesByGroup, filterBranchesByUser } = useContext(BranchesContext);
    const { group: userGroup, hasPermission } = useContext(AuthContext);
    const [getAllMainGroups] = useAsyncResource(useGetAllMainGroups, []);
    const [selectedGroup, setSelectedGroup] = useState<string | undefined>(undefined);
    const [selectedGroupOption, setSelectedGroupOption] = useState<{ value: string; label: string } | null>(null);
    const [selectedDistributor, setSelectedDistributor] = useState<User | null>(null);
    const shouldLimitGroups = !hasPermission([Role.ADMIN, Role.COORDINATOR]);

    const groups = getAllMainGroups()
        .filter((group) => !shouldLimitGroups || !userGroup?.mainGroup || group.mainGroup === userGroup.mainGroup)
        .flatMap((group) =>
            group.subGroups
                .filter((subGroup) => !shouldLimitGroups || !userGroup?.subGroup || subGroup === userGroup.subGroup)
                .map((subGroup) => ({
                    value: group.mainGroup+"-"+subGroup,
                    label: group.mainGroup+"-"+subGroup,
                }))
        );

    const [getDistributors] = useAsyncResource(
        useGetUsers,
        selectedGroup !== undefined
            ? { filter: { tags: [], search: selectedGroup } }
            : undefined,
        'DISTRIBUTOR,INSTALLER'
    );

    const { items: distributors } = getDistributors();
    const groupOptions = groups.length > 1 ? [{ value: "allGroups", label: t('allGroups') }, ...groups] : groups;
    const distributorOptions = [{ id: undefined, name: t('allDistributors') } as User, ...distributors];
    const allGroupsOption = groupOptions.find((option) => option.value === 'allGroups') ?? groupOptions[0] ?? null;
    const allDistributorsOption = distributorOptions[0] ?? null;

    const colors = getColors();
    return (
        <div className='d-flex branches-state-filters-container'>
            {Object.entries(colors).map(([key, value], index) => (
                <Button
                    key={index}
                    variant='link'
                    type='button'
                    onClick={() => {
                        filterBranchesByState(value);
                        setSelectedButton(index);
                    }}
                    className='btn btn-link rounded-0  border-left border-light '
                    data-toggle='tooltip'
                    data-placement='bottom'
                    title={`${t(key)}`}
                    style={{
                        backgroundColor: selectedButton === index ? 'rgb(235, 235, 235)' : '',
                    }}
                >
                    <FontAwesomeIcon icon={faCircle} color={value} className='mx-1' />
                </Button>
            ))}
            <Button
                variant='link'
                type='button'
                onClick={() => {
                    filterBranchesByState('');
                    setSelectedButton(null);
                }}
                className='btn btn-link rounded-0  border-left border-light '
                data-toggle='tooltip'
                data-placement='bottom'
                title={`${t('noFilter')}`}
            >
                <FontAwesomeIcon icon={faBan} color={'black'} size={'sm'} className='mx-1' />
            </Button>
            <Select
                className='w-100'
                value={selectedGroupOption ?? allGroupsOption}
                onChange={(newValue) =>{
                    setSelectedGroupOption(newValue);
                    if(newValue?.value === "allGroups"){
                        setSelectedGroup(undefined);
                    }else {
                        setSelectedGroup(newValue?.value);
                    }
                    void filterBranchesByGroup(newValue?.value);
                }
                }
                options={groupOptions}
                placeholder={t('group')}
            />
            <Select
                styles={optionSelectStyles}
                placeholder={t('distributor')}
                options={distributorOptions}
                value={selectedDistributor ?? allDistributorsOption}
                getOptionLabel={(user) => user? user.name : ""}
                getOptionValue={(user: User | null) => String(user?.id) ?? ''}
                onChange={(user: User | null) => {
                    setSelectedDistributor(user);
                    filterBranchesByUser(user?.id);
                }}
            />
        </div>
    );
};
